async function getThemeSettings(property) {
  return document.querySelector("html").dataset[`themeSettings${property}`];
}

export const isKlarnaEnabled = () => getThemeSettings("EnableKlarna");
